import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UsersApi } from '../clients';
import { usersKeys } from '../queryKeys';

/**
 * Saves an admin's edit of one identity, then refetches it so the profile shows
 * what auth-service stored (it normalises the phone number) rather than what
 * was typed.
 *
 * The global mutation toaster stays on: it relays auth-service's `error` body
 * verbatim, which is the message an admin needs on a refused edit.
 *
 * @param {string} identityId
 */
export const useUpdateLocationUser = (identityId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (changes) => UsersApi.updateUser(identityId, changes),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: usersKeys.locationUser(identityId) }),
  });
};
